<svg
  class="circular-indicator"
  [attr.viewBox]="viewBox"
>
  <circle
    class="circular-indicator__progress_ring circular-indicator__progress_ring__background"
    fill="white"
    [attr.stroke-width]="stroke"
    [attr.r]="radius"
    [attr.cx]="middle"
    [attr.cy]="middle"
  />
  <ng-container *ngIf="currentPercentage > basePercentage">
    <circle
      id="current"
      class="circular-indicator__progress_ring circular-indicator__progress_ring__current"
      stroke-linecap="round"
      fill="transparent"
      [attr.stroke-width]="stroke"
      [attr.r]="radius"
      [attr.cx]="middle"
      [attr.cy]="middle"
      [attr.stroke-dasharray]="dashArray"
      [attr.stroke-dashoffset]="getDashOffset(currentPercentage)"
    />
  </ng-container>
  <circle
    id="base"
    class="circular-indicator__progress_ring circular-indicator__progress_ring__base"
    stroke-linecap="round"
    fill="transparent"
    [attr.stroke-width]="stroke"
    [attr.r]="radius"
    [attr.cx]="middle"
    [attr.cy]="middle"
    [attr.stroke-dasharray]="dashArray"
    [attr.stroke-dashoffset]="getDashOffset(basePercentage)"
  />
  <ng-container *ngIf="capShouldBeVisible()">
    <circle
      id="cap"
      class="circular-indicator__progress_ring circular-indicator__progress_ring__current"
      stroke-linecap="round"
      fill="transparent"
      [attr.stroke-width]="stroke"
      [attr.r]="radius"
      [attr.cx]="middle"
      [attr.cy]="middle"
      [attr.stroke-dasharray]="'1 ' + circumference"
      [attr.stroke-dashoffset]="getDashOffset(currentPercentage) + 2"
    />
  </ng-container>
  <text
    class="circular-indicator__text circular-indicator__text__base"
    dominant-baseline="middle"
    text-anchor="middle"
    [attr.x]="middle"
    [attr.y]="middle"
    [ngClass]="{'circular-indicator__text__base--small': currentPercentage > basePercentage}"
  >
  {{ basePercentage }}
  </text>
  <ng-container *ngIf="currentPercentage > basePercentage">
    <text
      class="circular-indicator__text circular-indicator__text__current"
      dominant-baseline="middle"
      text-anchor="middle"
      [attr.x]="middle"
      [attr.y]="middle"
    >
    {{ currentPercentage }}
    </text>
  </ng-container>
</svg>
